import * as types from './types';

const initialState = {
  notifications: [],
  isLoading: false,
  error: null,
  totalCount: 0,
  totalunreadcount: 0,
  currentPage: 1,
  totalPages: 1,
  totalRecords: 0,
  isModalOpen: false
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notifications: action.payload.data || [],
        totalCount: action.payload.totalRecords || 0,
        totalunreadcount: action.payload.totalunreadcount || 0,
        totalRecords: action.payload.totalRecords || 1,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 1
      };
    case types.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.MARK_NOTIFICATION_READ_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case types.MARK_NOTIFICATION_READ_SUCCESS:
      // Instead of filtering out the notification, update its read status
      const updatedNotifications = state.notifications.map(notification => {
        // Check both possible ID fields and read status fields
        const notificationId = notification.id || notification.admin_notification_id;
        
        if (notificationId === action.payload) {
          return {
            ...notification,
            is_read: true,
            is_readed: true // Update both fields to ensure compatibility
          };
        }
        return notification;
      });
      
      return {
        ...state,
        isLoading: false,
        notifications: updatedNotifications,
        unreadCount: Math.max(0, state.unreadCount - 1) 
      };
    case types.MARK_NOTIFICATION_READ_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.SET_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadCount: action.payload
      };
    case types.OPEN_NOTIFICATION_MODAL:
      return {
        ...state,
        isModalOpen: true
      };
    case types.CLOSE_NOTIFICATION_MODAL:
      return {
        ...state,
        isModalOpen: false
      };
    default:
      return state;
  }
};

export default notificationReducer;